
import {getHistoryBonusGetById} from '../api/getHistoryBonusGetById';
import {setGetHistoryBonusGetByIdAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetHistoryBonusGetById = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getHistoryBonusGetById(params);

            if (data.status === 'success') {
                const bonuses = [...getState().usersMobile.bonuses_history.data];
                bonuses.push(data.data);
                
                dispatch(setGetHistoryBonusGetByIdAction({
                    data: bonuses.flat(1),
                    countPage: data.count
                }));        
                dispatch(setLoadingAction(false))   
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetHistoryBonusGetById
}